<ngx-spinner *ngIf="hideSpinner != false" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
  type="ball-clip-rotate-multiple" [fullScreen]="true">
</ngx-spinner>
<div class="menu-large">
  <div class="container-fluid  ">
    <div class="row elhoo_dashboardMenu_menuPosition pt-5 fixedPosiion ">
      <div class="col-12 col-md-12 pt-5">
        <div class="header__logo">
          <img src="assets/icons/logo.svg" style="margin-left: 12px;" width="31px" height="40" alt="" loading="lazy" />
  
        </div>
        
        <div routerLink="/admin/device" placement="right" ngbTooltip="Boîtiers" (click)="RedirectGo('/admin/device')"
          (click)="setrouter('/admin/device')" class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/device' ,
                        elhoo_dashboardMenu_IconSvgShadow_off : linkSelected != '/admin/device' }">
          <a [ngClass]="{BtnLinkActive: linkSelected == '/admin/device' }">
            <img
              src="{{linkSelected == '/admin/device' ? 'assets/icons/boitier_admin_selected.svg' : 'assets/icons/boitier_admin.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/device' }" />
          </a>
        </div>
        <div routerLink="/admin/companypartner" placement="right" ngbTooltip="Compagnies"
          (click)="setrouter('/admin/companypartner')" class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/companypartner' ,
          elhoo_dashboardMenu_IconSvgShadow_off : linkSelected != '/admin/companypartner' }">
          <a (click)="RedirectGo('/admin/companypartner')"
            [ngClass]="{BtnLinkActive: linkSelected == '/admin/companypartner' }">
            <img
              src="{{linkSelected == '/admin/companypartner' ? 'assets/icons/compagnie_selected.svg' : 'assets/icons/compagnie_admin.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/companypartner' }" />
          </a>
        </div>
        <div routerLink="/admin/vehicule" placement="right" ngbTooltip="Véhicules"
          (click)="setrouter('/admin/vehicule')" class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/vehicule' ,
                        elhoo_dashboardMenu_IconSvgShadow_off : linkSelected != '/admin/vehicule' }">
          <a (click)="RedirectGo('/admin/vehicule')" [ngClass]="{BtnLinkActive: linkSelected == '/admin/vehicule' }">
            <img
              src="{{linkSelected == '/admin/vehicule' ? 'assets/icons/unit_admin_selected.svg' : 'assets/icons/unit_admin.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/vehicule' }" />
          </a>
        </div>
        <div routerLink="/admin/driver" placement="right" ngbTooltip="Conducteurs" (click)="setrouter('/admin/driver')"
          class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/driver' ,
                        elhoo_dashboardMenu_IconSvgShadow_off : linkSelected != '/admin/driver' }">
          <a (click)="RedirectGo('/admin/driver')" [ngClass]="{BtnLinkActive: linkSelected == '/admin/driver' }">
            <img
              src="{{linkSelected == '/admin/driver' ? 'assets/icons/conducteur_admin.svg' : 'assets/icons/conducteur_admin_selected.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/driver' }" />
            <mde-popover #drivernotif="mdePopover" [mdePopoverOverlapTrigger]="false">
              <mat-card style="max-width: 300px">
                <mat-card-content>
                  Conducteurs.
                </mat-card-content>
              </mat-card>
            </mde-popover>
          </a>
        </div>
        <div routerLink="/admin/user" placement="right" ngbTooltip="Utilisateurs" (click)="setrouter('/admin/user')"
          class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/user' ,
                      elhoo_dashboardMenu_IconSvgShadow_off : linkSelected != '/admin/user' }">
          <a (click)="RedirectGo('/admin/user')" [ngClass]="{BtnLinkActive: linkSelected == '/admin/user' }">
            <img
              src="{{linkSelected == '/admin/user' ? 'assets/icons/user_admin_selected.svg' : 'assets/icons/user_admin.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/admin/user' }" />
            <mde-popover #usernotif="mdePopover" [mdePopoverOverlapTrigger]="false">
              <mat-card style="max-width: 300px">
                <mat-card-content>
                  Utilisateurs.
                </mat-card-content>
              </mat-card>
            </mde-popover>
          </a>
        </div>
        <div (click)="logout()" class="elhoo_dashboardMenu_helpIconSvgStyle fixed-bottom mb-4">
          <div placement="right" ngbTooltip="Se déconnecter" class="elhoo_dashboardMenu_IconSvgStyle">
            <a>
              <img src="assets/icons/deconect.svg">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>